function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.0999 6.93998C20.0999 7.47998 19.8099 7.96995 19.3499 8.21995L17.6099 9.15995L16.1299 9.94999L13.0599 11.61C12.7299 11.79 12.3699 11.88 11.9999 11.88C11.6299 11.88 11.2699 11.79 10.9399 11.61L4.6499 8.21995C4.1899 7.96995 3.8999 7.47998 3.8999 6.93998C3.8999 6.39998 4.1899 5.90995 4.6499 5.65995L6.6199 4.59996L8.18991 3.74998L10.9399 2.27C11.5999 1.91 12.3999 1.91 13.0599 2.27L19.3499 5.65995C19.8099 5.90995 20.0999 6.39998 20.0999 6.93998Z",
  fill: "#161F2C"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.90021 12.7899L4.0502 9.85989C3.6002 9.62989 3.08021 9.65989 2.65021 9.91989C2.22021 10.1799 1.97021 10.6399 1.97021 11.1399V16.6699C1.97021 17.6299 2.5002 18.4899 3.3602 18.9199L9.21021 21.8399C9.4102 21.9399 9.63022 21.9899 9.85022 21.9899C10.1102 21.9899 10.3702 21.9199 10.6002 21.7699C11.0302 21.5099 11.2802 21.0499 11.2802 20.5499V15.0199C11.2902 14.0799 10.7602 13.2199 9.90021 12.7899Z",
  fill: "#161F2C"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.03 11.1502V16.6801C22.03 17.6301 21.5 18.4901 20.64 18.9201L14.79 21.8501C14.59 21.9501 14.37 22.0001 14.15 22.0001C13.89 22.0001 13.63 21.9302 13.39 21.7802C12.97 21.5202 12.71 21.0601 12.71 20.5601V15.0401C12.71 14.0801 13.24 13.2201 14.1 12.7901L16.25 11.7201L17.75 10.9701L19.95 9.87013C20.4 9.64013 20.92 9.66012 21.35 9.93012C21.77 10.1901 22.03 10.6502 22.03 11.1502Z",
  fill: "#161F2C"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.6101 9.15997L16.1301 9.95001L6.62012 4.59998L8.19012 3.75L17.3701 8.92999C17.4701 8.98999 17.5501 9.06997 17.6101 9.15997Z",
  fill: "#B4B4B4"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.75 10.97V13.24C17.75 13.65 17.41 13.99 17 13.99C16.59 13.99 16.25 13.65 16.25 13.24V11.72L17.75 10.97Z",
  fill: "#B4B4B4"
});

var SvgDeliveryLightActive = function SvgDeliveryLightActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDeliveryLightActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Delivery_light_active.76bcb78a.svg";
export { ForwardRef as ReactComponent };